"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Panel — the one boxed region used by all three applications.
 * Implements surface-identity-and-shell.md §3.
 *
 * The frame carries the per-surface tint (--color-surface-*, set once on the app
 * root); the body stays white so dense data never sits on a colour. Header order
 * is fixed: icon → title → count pill → command group right.
 *
 *   <Panel title="Ready to deploy" count="3 staged" actions={<Button .../>}>
 *     <table>…</table>
 *   </Panel>
 *
 * Titles are sentence case. `count` is the pill text ("20 matching"); omit it
 * when there is nothing to count.
 *
 * `controls` is the view group — the selectors that say WHICH content the panel
 * is showing (Sessions ⇄ Matrix, Results ⇄ Timeline) plus any subtitle that
 * describes it. It sits left, beside the title, because it names the content;
 * `actions` are the commands that ACT on that content (Export, search, full
 * screen) and stay right. Keeping the two apart stops a long subtitle from
 * squeezing the commands off the end of the head.
 *
 * `titleAs` renders the title as a different element — pass "h2" where the panel
 * title is the document heading for that region, so the page keeps a real
 * heading outline for screen readers. It only changes the tag; the styling is
 * always .panel__title.
 */const Panel = /*#__PURE__*/_react.default.forwardRef(({
  title,
  titleAs: TitleTag = 'span',
  icon,
  count,
  controls,
  actions,
  children,
  className = '',
  style,
  bodyClassName = '',
  bodyStyle,
  bodyRef,
  ...rest
}, ref) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
  ref: ref,
  className: `panel ${className}`.trim(),
  style: style,
  ...rest,
  children: [(title || icon || count || controls || actions) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "panel__head",
    children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "panel__icon",
      children: icon
    }), title && /*#__PURE__*/(0, _jsxRuntime.jsx)(TitleTag, {
      className: "panel__title",
      children: title
    }), count != null && count !== '' && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "panel__count",
      children: count
    }), controls && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "panel__ctrls",
      children: controls
    }), actions && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "panel__acts",
      children: actions
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: bodyRef,
    className: `panel__body ${bodyClassName}`.trim(),
    style: bodyStyle,
    children: children
  })]
}));
Panel.displayName = 'Panel';
var _default = exports.default = Panel;